<template>
  <section style="display: inline;">
    <i
      id="helpTour"
      class="fa fa-question-circle text-white"
      style="cursor: pointer;padding-top: 0.8rem;"
      @click="start()"
    ></i>
  </section>
</template>

<script>
  export default {
    methods: {
      start() {
        this.$bvModal.show('welcome-modal');
      },
    },
  };
</script>

<style></style>
